import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "@/components/ScrollToTop";
import AnnouncementBanner from "@/components/AnnouncementBanner";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink">
      <AnnouncementBanner />
      <Header />
      {/* key on pathname re-mounts children, triggering the fade-up animation */}
      <main
        key={pathname}
        style={{ paddingTop: "calc(5rem + var(--fic-banner-h, 0px))" }}
        className="flex-1 page-fade-up"
      >
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
